<template>
  <section class="py-20 bg-white">
    <div class="container mx-auto px-4">
      <div class="text-center mb-16">
        <div class="text-title font-bold text-[#333333] leading-tight mb-6">
          POPULAR CATEGORIES
        </div>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <div
          v-for="feature in features"
          :key="feature.name"
          @click="navitoProducts(feature)"
        >
          <img
            class="w-[90%] mx-auto cursor-pointer"
            :src="feature.imageUrl"
            alt=""
          />
        </div>
        <!-- <div>
          <img class="w-[90%] mx-auto" src="@/assets/popular-02.jpg" alt="" />
        </div>
        <div>
          <img class="w-[90%] mx-auto" src="@/assets/popular-03.jpg" alt="" />
        </div>
        <div>
          <img class="w-[90%] mx-auto" src="@/assets/popular-04.jpg" alt="" />
        </div> -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Template',
  components: {},
  data() {
    return {
      features: [
        {
          name: 'Lapel Pin',
          imageUrl: require('@/assets/popular-01.jpg')
        },
        {
          name: 'Keychain',
          imageUrl: require('@/assets/popular-02.jpg')
        },
        {
          name: 'Challenge Coin',
          imageUrl: require('@/assets/popular-03.jpg')
        },
        {
          name: 'Medal',
          imageUrl: require('@/assets/popular-04.jpg')
        }
      ]
    }
  },
  methods: {
    navitoProducts(item) {
      this.$bus.$emit('navi-page', '/products')
      this.$router.push({
        path: '/products',
        query: { category: item.name }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/index/featuresSection.vue